import { ApprovedSystemsComponent } from './pages/approved-systems/approved-systems.component';
import { ApprovedSystemStandaloneViewComponent } from './pages/approved-system-view/approved-system-standalone-view.component';
import { CreateApprovedSystemComponent } from './pages/create-approved-system/create-approved-system.component';

export const APPROVED_SYSTEMS_ROUTES = [
  { path: '', component: ApprovedSystemsComponent },
  {
    path: 'new',
    component: CreateApprovedSystemComponent,
    data: { breadcrumb: 'New System' },
  },
  {
    path: ':id',
    component: ApprovedSystemStandaloneViewComponent,
    data: { breadcrumb: 'System Details' },
  },
];
